import React from "react";
import { number } from "prop-types";

import "./cameraIcon.m.css";

const CameraIcon = ({ width = 15, height = 15 }) => (
  <div styleName="wrapper">
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 42 42">
      <g transform="translate(.2)">
        <path d="M0 0H42V42H0z" transform="translate(-.2)" fill="transparent" />
        <g transform="translate(.977 3.418)">
          <ellipse cx="6.407" cy="6.282" fill="#35144f" rx="6.407" ry="6.282" transform="translate(13.616 13.349)" />
          <path
            d="M18.016 4l-3.664 3.926H8a3.965 3.965 0 0 0-4 3.926v23.557a3.965 3.965 0 0 0 4 3.926h32.042a3.965 3.965 0 0 0 4-3.926V11.852a3.965 3.965 0 0 0-4-3.926h-6.348L30.03 4zm6.007 29.446a9.817 9.817 0 1 1 10.012-9.815 9.919 9.919 0 0 1-10.012 9.815z"
            fill="#35144f"
            transform="translate(-4 -4)"
          />
        </g>
      </g>
    </svg>
  </div>
);

CameraIcon.propTypes = {
  width: number,
  height: number,
};

export default CameraIcon;
